<!-- 
  号码展示
  lovi 2020-07-13
 -->
<template>
  <div class="childRoute-wrapper">
    <van-nav-bar
      class="gradient"
      :title="
        flag == 0
          ? $t('recharge.batchPhoneFee')
          : flag == 1
          ? $t('recharge.batchDataTraffic')
          : flag == 2
          ? $t('recharge.timingBatchPhoneFee')
          : flag == 3
          ? $t('recharge.timingBatchDataTraffic')
          : $t('recharge.batchRecharge')
      "
      :fixed="true"
      left-arrow
      @click-left="navbarback"
    >
      <!-- <span slot="right" @click="_linkFun('/batch/record?type=3','BatchRecord')">充值记录</span> -->
    </van-nav-bar>

    <div class="scroll-wrapper" v-if="numberList.length">
      <div class="bg"></div>
      <scroll ref="scroll">
        <div class="column-placeholder"></div>
        <div class="column show-set" v-if="flag == 2 || flag == 3">
          <task-timing :taskInfo="taskInfo" @getTaskTiming="getTaskTiming" />
        </div>
        <div
          class="column number-list"
          v-for="(item, index) in numberList"
          :key="index"
        >
          <div class="number-title">
            <span>{{ item.name }}</span>
          </div>
          <div class="number-wrap" :class="{ active: item.showAll }">
            <van-cell
              :title="_phoneFormat(num)"
              v-for="(num, numIndex) in item.phones"
              :key="numIndex"
              :is-link="numIndex == 0 ? true : false"
              :arrow-direction="item.showAll ? 'up' : 'down'"
              @click="showAllFun(index)"
            />
          </div>
          <template v-if="flag == 0 || flag == 2">
            <money-list
              v-if="item.denomination.length"
              :money.sync="item.amount"
              :moneyId.sync="item.denomination_id"
              :list="item.denomination"
              :custom="item.operator_recharge"
              :rate="Number(curPay.exchange_rate)"
              :recently="item.recently"
            />
            <div v-else class="no-operator text-gray">
              {{ $t("recharge.operatorNotSupport") }}
            </div>
          </template>

          <template v-if="flag == 1 || flag == 3">
            <van-cell-group
              v-if="operatorState[item.operator_id] == 1"
              class="combo-choose"
            >
              <van-cell
                class="combo-title"
                :title="$t('recharge.dataChargeSelectPackage')"
                @click="clickCombo(item, index)"
                is-link
              />
              <van-cell
                v-if="item.content"
                :title="item.content"
                :value="item.amount + 'P'"
              />
            </van-cell-group>
            <div v-else class="no-operator text-gray">
              {{ $t("recharge.operatorNotSupport") }}
            </div>
          </template>
        </div>

        <pay-list
          v-if="flag == 0 || flag == 1"
          :showDiscount="flag == 0 ? true : false"
          :money.sync="totalMoney"
          :type="2"
          @getCurPay="getCurPay"
        />

        <div class="button-wrap">
          <van-button block type="primary" @click="rechargeNow">
            {{
              flag == 2 || flag == 3
                ? $t("common.submit")
                : $t("common.rechargeNow")
            }}
          </van-button>
          <p class="tips" v-if="flag != 2 && flag != 3">
            {{ $t("common.payFeesTips") }}
          </p>
        </div>
      </scroll>
    </div>

    <transition name="slide">
      <combo
        v-if="comboFlag"
        :comboFlag.sync="comboFlag"
        :operatorId.sync="operatorId"
        @getComboInfo="getComboInfo"
      />
    </transition>

    <enter-payPsd
      :payPsdFlag.sync="payPsdFlag"
      :data="payPsdData"
      @getPayPsd="getPayPsd"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MoneyList from "@/components/moneyList";
import Combo from "@/components/recharge/combo";
import PayList from "@/components/payList";
import EnterPayPsd from "@/components/enterPayPsd";
import TaskTiming from "@/components/recharge/taskTiming";
export default {
  props: {
    numberList: {
      //展示的数组
      type: Array,
      default: function() {
        return [];
      }
    },
    nextStepFlag: {
      //显示隐藏
      type: Boolean,
      default: function() {
        return false;
      }
    },
    flag: {
      //当前选中的玩法
      type: Number,
      default: function() {
        return 0;
      }
    },
    taskInfo: {
      //定时任务信息
      type: Object,
      default: function() {
        return {};
      }
    },
    operatorState: {
      //运营商支持流量套餐状态
      type: Object,
      default: function() {
        return {};
      }
    },
    totalMoney: {
      // 总金额
      type: Number,
      default: function() {
        return 0;
      }
    }
  },
  components: {
    MoneyList,
    Combo,
    PayList,
    EnterPayPsd,
    TaskTiming
  },
  data() {
    return {
      comboFlag: false, //选择套餐
      comboInfo: {}, //套餐选择的信息
      comboIndex: 0, //当前点击套餐在总数据中的下标,获取号码用的

      thisDay: 1, //设置定时任务时的日期
      switchFlag: true, //设置定时任务时的开关

      payPsdFlag: false,
      payPsdData: {
        money: ""
      },
      payPsd: "",

      curPay: {} //当前支付信息
    };
  },
  created() {},
  mounted() {
    if (this.taskInfo.timer_id) {
      this.thisDay = this.taskInfo.day;
      this.switchFlag = this.taskInfo.state == 1 ? true : false;
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    navbarback() {
      this.$emit("update:nextStepFlag", false);
    },
    getTaskTiming(data) {
      //获取定时任务的信息
      console.log("getTaskTiming", data);
      let vm = this;
      vm.thisDay = data.thisDay;
      vm.switchFlag = data.switchFlag;
    },
    clickCombo(data, index) {
      //选择套餐
      let vm = this;
      vm.comboIndex = index;
      vm.operatorId = data.operator_id;
      vm.comboFlag = true;
    },
    getComboInfo(data) {
      //获取套餐信息
      let vm = this;
      console.log("getComboInfo", data);
      let arr = vm.numberList;
      let obj = arr[vm.comboIndex];
      obj.denomination_id = data.denomination_id;
      obj.amount = Number(data.amount);
      obj.content = data.content;
      vm.$set(arr, vm.comboIndex, obj);
      vm.$emit("update:numberList", arr);
      console.log("numberList", arr);
      vm.comboFlag = false;
    },
    getCurPay(data) {
      //获取当前支付信息
      this.curPay = data;
      console.log("curPay", data);
    },
    getPayPsd(data) {
      // 验证支付密码
      this.payPsd = data;
      this.rechargeNow();
    },
    rechargeNow() {
      //立即充值
      let vm = this;
      let params = {};
      let list = [];
      for (let key of vm.numberList) {
        if (
          ((vm.flag == 0 || vm.flag == 2) && key.denomination.length) ||
          ((vm.flag == 1 || vm.flag == 3) &&
            vm.operatorState[key.operator_id] == 1)
        ) {
          let obj = {};
          obj.name = key.name;
          obj.operator_id = key.operator_id;
          obj.denomination_id = key.denomination_id;
          obj.amount = key.amount;
          obj.content = key.content;
          obj.phones = key.phones;
          list.push(obj);
        }
      }
      if (!list.length) {
        vm.$toast(vm.$t("recharge.operatorNotSupport"));
        return false;
      }
      let money = 0;
      for (let key of list) {
        if (key.amount == 0) {
          if (vm.flag == 1 || vm.flag == 3) {
            vm.$Message.info(vm.$t("recharge.pleaseSelectPackage"));
          } else {
            vm.$Message.info(vm.$t("common.enterAmount"));
          }
          return false;
        }
        if (vm.flag == 0 || vm.flag == 2) {
          if (
            key.operator_recharge &&
            (key.operator_recharge.amount_mini ||
              key.operator_recharge.amount_max)
          ) {
            if (key.amount < Number(key.operator_recharge.amount_mini)) {
              vm.$Message.info(
                vm.$t("common.amountCannotMin") +
                  key.operator_recharge.amount_mini
              );
              return;
            }
            if (key.amount > Number(key.operator_recharge.amount_max)) {
              vm.$Message.info(
                vm.$t("common.amountCannotMax") +
                  key.operator_recharge.amount_max
              );
              return;
            }
          }
        }
        money += key.phones.length * key.amount;
      }
      params.type =
        vm.flag == 0 || vm.flag == 2
          ? 20
          : vm.flag == 1 || vm.flag == 3
          ? 21
          : "";
      if (vm.flag == 0 || vm.flag == 1) {
        // 批量充值
        if (vm.curPay.type == 3 && money > Number(vm.userInfo.money_usable)) {
          vm.$toast(vm.$t("recharge.insufficientBalanceChooseOtherPay"));
          return false;
        }
        if (vm.curPay.type == 3 && vm.payPsd == "") {
          vm.payPsdData.money = money.toFixed(2);
          vm.payPsdFlag = true;
          return;
        }
        params.batch = JSON.stringify(list);
        params.pay_password = vm.payPsd;
        params.totalMoney = money;
        params.payment_id = vm.curPay.payment_id; //支付方式
        vm.payBatchCalls(params);
      }
      if (vm.flag == 2 || vm.flag == 3) {
        // 定时任务
        params.params = JSON.stringify(list);
        params.day = vm.thisDay;
        params.state = vm.switchFlag ? 1 : 0;
        if (vm.taskInfo.timer_id) {
          // 编辑任务
          params.timer_id = vm.taskInfo.timer_id;
        }
        vm.setTimes(params);
      }
    },
    payBatchCalls(params) {
      // 话费流量批量充值
      let vm = this;
      vm.$post("/app/recharge/payBatchCalls", params, { loading: true }).then(
        res => {
          console.log("payBatchCalls", res);
          let routeData = res;
          routeData.tips = true;
          if (vm.curPay.type == 3) {
            // 3.余额
            routeData.button = true;
            vm.$router.push({
              path: "/detail",
              name: "detail",
              query: {
                flag: vm.flag == 0 ? 20 : 21,
                order_id: res.order_id
              },
              params: routeData
            });
          }
          if (vm.curPay.type == 5) {
            // 5.微信扫码支付
            routeData.money = params.totalMoney.toFixed(2) + "P";
            vm.$router.push({
              path: "/payCode",
              name: "payCode",
              query: { flag: vm.flag == 0 ? 20 : 21, payType: vm.curPay.type },
              params: routeData
            });
          }
        }
      );
    },
    setTimes(params) {
      // 配置定时任务
      let vm = this;
      vm.$post("/app/recharge/setTimes", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("setTimes", res);
        vm.$toast(res.msg);
        if (res.code == 0) {
          if (vm.taskInfo.timer_id) {
            vm.$emit("update:getTaskList", true);
          }
          vm.navbarback();
        }
      });
    },
    showAllFun(index) {
      //展示所有的号码
      let vm = this;
      let thisList = JSON.parse(JSON.stringify(vm.numberList));
      if (thisList[index].phones.length < 2) {
        return;
      }
      if (thisList[index].showAll) {
        thisList[index].showAll = false;
      } else {
        thisList[index].showAll = true;
      }
      vm.$emit("update:numberList", thisList);
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.no-operator {
  margin-top: 10px;
  text-align: center;
  font-size: 14px;
}
.scroll-wrapper {
  background: #f4f4f4;
  .column-placeholder {
    height: 15px;
    width: 100%;
  }
  .column {
    margin-top: 0;
  }
  .bg {
    height: 50px;
    background: linear-gradient(90deg, #2043ac, #130f73);
  }

  /deep/.scroll-content {
    min-height: 100%;
  }
  .button-wrap {
    p {
      text-align: center;
      color: #9b9b9b;
      font-size: 11px;
      padding: 14px 0;
      span {
        display: block;
      }
    }
  }

  .number-list {
    padding: 16px 12px;
    .number-title {
      font-size: 16px;
      margin-bottom: 8px;
      font-weight: 500;
      color: #4a4a4a;
    }
    .number-wrap {
      padding: 8px 12px;
      border: 1.1px solid #b6b6b6;
      border-radius: 5px;
      overflow: hidden;
      height: 42px;
      transition: all 0.5s linear;
      /deep/.van-cell {
        padding: 0;
        height: 42px;
        .van-cell__title {
          font-size: 16px;
        }
        &:not(:last-child)::after {
          display: none;
        }
      }
      &.active {
        height: auto;
        /deep/.van-cell {
          height: auto;
        }
      }
    }

    .combo-choose {
      border-radius: 5px;
      border: 1.1px solid #b6b6b6;
      overflow: hidden;
      margin-top: 12px;
      .van-cell {
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .van-cell__title {
          font-size: 14px;
          flex-grow: 1;
          max-width: 234px;
          display: flex;
          align-items: center;
          color: #9b9b9b;
          span {
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .van-cell__value {
          flex: initial;
          font-size: 16px;
          color: #4a4a4a;
        }
        &.combo-title {
          .van-cell__title {
            font-size: 16px;
            color: #4a4a4a;
          }
          .van-cell__value {
            flex: initial;
            color: #9b9b9b;
          }
        }
      }
      .van-cell:not(:last-child)::after {
        left: 0;
      }
    }
  }
}
</style>
